import { SELECIONAR_RESERVA_PARA_CRIAR,
  ALTERAR_PEDIDO_RESERVA_CRIADA,
  ALTERAR_SITUACAO_FORMA_PAGAMENTO_RESERVA_CRIADA,
  ALTERAR_FORMA_PAGAMENTO_RESERVA_CRIADA } from '../types'

export function selecionarReservaParaCriada (reserva) {
  return {
    type: SELECIONAR_RESERVA_PARA_CRIAR,
    payload: reserva
  }
}

export function alterarReservaParaCriada (idPedido) {
  return {
    type: ALTERAR_PEDIDO_RESERVA_CRIADA,
    payload: idPedido
  }
}

export function alterarFormaPagamentoReservaCriada (formaPagamento) {
  return async (dispatch) => {
    try {
      dispatch({
        type: ALTERAR_FORMA_PAGAMENTO_RESERVA_CRIADA,
        payload: formaPagamento
      });

    } catch (error) {
      console.error('Erro ao alterar forma de pagamento:', error);
      throw error; // Rethrow o erro para tratar no componente
    } 
  }
}

export function alterarSituacaoFormaPagamentoReservaCriada (formaPagamento, situacao, habilitado) {
  return async (dispatch) => {
    try {
      dispatch({
        type: ALTERAR_SITUACAO_FORMA_PAGAMENTO_RESERVA_CRIADA,
        payload: { formaPagamento, situacao, habilitado }
      });

    } catch (error) {
      console.error('Erro ao alterar situação da forma de pagamento:', error);
      throw error; // Rethrow o erro para tratar no componente
    } 
  }
}
